import { observeElement } from '@uvocore-front/utils';

const stages = ['proposal', 'introduction', 'literature', 'dissertation', 'conclusion'];

let activeStage = 'proposal';

function runAnimation() {
  const animateBlock = document.querySelector('[data-animate-block]');
  animateBlock.classList.remove('animate-1');
  animateBlock.classList.remove('animate-2');

  setTimeout(() => {
    animateBlock.classList.add('animate-1');

    setTimeout(() => {
      animateBlock.classList.add('animate-2');
    }, 300);
  }, 600);
}

function tabButtonsClickInit() {
  const tabButtons = document.querySelectorAll('.hiw__nav .hiw__nav__item');
  const progressBar = document.querySelector('.hiw__progress');

  [...tabButtons].forEach((btn) => {
    btn.addEventListener('click', (ev) => {
      // reset active classes
      tabButtons.forEach((b) => b.classList.remove('is-active'));
      runAnimation();
      activeStage = ev.target.dataset.stage;
      progressBar.style.width = ev.target.dataset.width;
      btn.classList.add('is-active');
    });
  });
}

function nextButtonCLickInit() {
  const tabButtons = [...document.querySelectorAll('.hiw__nav .hiw__nav__item')];
  const nextButton = document.querySelector('.hiw__button-next');
  const progressBar = document.querySelector('.hiw__progress');

  const handleClick = () => {
    let active = activeStage;

    stages.forEach((s, index) => {
      if (s === activeStage) {
        let next;
        if (stages[index + 1]) {
          next = tabButtons.find((b) => b.dataset.stage === stages[index + 1]);
          active = stages[index + 1];
        } else {
          // eslint-disable-next-line prefer-destructuring
          next = tabButtons[0];
          active = 'proposal';
        }
        tabButtons.forEach((b) => b.classList.remove('is-active'));
        next.classList.add('is-active');
        progressBar.style.width = next.dataset.width;
      }
    });

    activeStage = active;
  };

  nextButton.addEventListener('click', () => {
    handleClick();
    runAnimation();
  });
}

observeElement({
  element: '[data-hiw-block]',
  marginValue: 300,
  callback: () => {
    runAnimation();
    tabButtonsClickInit();
    nextButtonCLickInit();
  },
});
